import React from "react";
import CalendarDayCell from "./CalendarDayCell";

// Arabic weekday initials (Sun→Sat). Slicing the full names ("الأحد" → "الأح")
// produced broken-looking stubs on phones.
const AR_INITIALS = ["ح", "ن", "ث", "ر", "خ", "ج", "س"];

const CalendarGrid = ({
  days,
  dayNames,
  selectedDates,
  vacationDates,
  dateRangeStart,
  dateRangeEnd,
  dateRangeMode,
  getEventsForDate,
  styles,
  screenSize,
  language,
  t,
  onDateClick,
  onEventClick,
  onShowMoreEvents,
}) => {
  const shortLabel = (day, index) => {
    if (!screenSize.isMobile) return day;
    return language === "ar" ? AR_INITIALS[index] : day.slice(0, 1);
  };

  return (
    <div style={styles.calendarGrid}>
      {dayNames.map((day, index) => (
        <div key={day} style={styles.calendarDayHeader}>
          {shortLabel(day, index)}
        </div>
      ))}

      {days.map((dayObj, index) => (
        <CalendarDayCell
          key={index}
          dayObj={dayObj}
          index={index}
          selectedDates={selectedDates}
          vacationDates={vacationDates}
          dateRangeStart={dateRangeStart}
          dateRangeEnd={dateRangeEnd}
          dateRangeMode={dateRangeMode}
          getEventsForDate={getEventsForDate}
          styles={styles}
          screenSize={screenSize}
          language={language}
          t={t}
          onDateClick={onDateClick}
          onEventClick={onEventClick}
          onShowMoreEvents={onShowMoreEvents}
        />
      ))}
    </div>
  );
};

export default CalendarGrid;
